import { useEffect, useRef } from 'react';
import Lottie from 'react-lottie-player';

import arrowDownAnimation from '@/components/lottie/arrow-down.json';

export type ArrowIconProps = {
  active?: boolean;
  className?: string;
};

export const ArrowIcon = ({ active, className = '' }: ArrowIconProps) => {
  const lottieRef = useRef(null);

  useEffect(() => {
    if (!lottieRef.current) return;
    lottieRef.current.play();
  }, [active]);

  return (
    <Lottie
      ref={lottieRef}
      animationData={arrowDownAnimation}
      loop={true}
      className={`h-10 ${className}`}
    />
  );
};
